import { render } from "./custom_export_fields.vue?vue&type=template&id=b54035a2&scoped=true&lang=pug"
import script from "./custom_export_fields.vue?vue&type=script&lang=js"
export * from "./custom_export_fields.vue?vue&type=script&lang=js"

import "./custom_export_fields.vue?vue&type=style&index=0&id=b54035a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54035a2"]])

export default __exports__